import { render, staticRenderFns } from "./GridContainerItem.vue?vue&type=template&id=bd058d70&scoped=true&"
import script from "./GridContainerItem.vue?vue&type=script&lang=js&"
export * from "./GridContainerItem.vue?vue&type=script&lang=js&"
import style0 from "./GridContainerItem.vue?vue&type=style&index=0&id=bd058d70&lang=scss&scoped=true&"
import style1 from "./GridContainerItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd058d70",
  null
  
)

export default component.exports